
import styles from '../style.module.css';
import useCountUp from "../hooks/useCountUp";

function AdvantagesItem({ value, title, text, startAnimation }) {

    const number = useCountUp(value, startAnimation);

    const suffix = value.replace(/[0-9]/g, '');

    return (
        <div className={styles.advantages_item}>
            <span className={styles.advantages_item_value}>
                {number}
                {suffix}
            </span>
            <span className={styles.advantages_item_title}>
                { title }
            </span>
            <span className={styles.advantages_item_text}>
                { text }
            </span>
        </div>
    )
}

export default AdvantagesItem
